import Creator from './Creator';
import ScreenshotImage from './ScreenshotImage';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';

const ViewItemDialog = ({ item, badge, onClose }) => {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto">
        <DialogHeader className="space-y-3">
          {badge && <div>{badge}</div>}
          <DialogTitle className="text-xl leading-snug">{item.title}</DialogTitle>
          <DialogDescription asChild>
            <div>
              <Creator item={item} />
            </div>
          </DialogDescription>
        </DialogHeader>
        <Separator />
        {item.description ? (
          <div className="whitespace-pre-wrap text-sm leading-relaxed">{item.description}</div>
        ) : (
          <div className="text-sm italic text-muted-foreground">No description</div>
        )}
        {item.screenshots.length > 0 && (
          <div className="space-y-3">
            <div className="text-sm font-medium">Screenshots ({item.screenshots.length})</div>
            {item.screenshots.map((screenshot) => (
              <ScreenshotImage key={screenshot.object} screenshot={screenshot} className="min-h-[120px] w-full bg-muted object-contain" />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewItemDialog;
